module.exports = __webpack_public_path__ + "img/2.d17f8aba.png";